export default "__VITE_ASSET__5da3077a__"